import { useMemo } from 'react';

import {
  convertToNavigationLevelPathConfig,
  resolveValidRoutingStructure,
} from '~/scenes/PortalViews/components/StructuredModuleRouter/data';
import { NavigationRoutingStructure } from '~/scenes/PortalViews/components/StructuredModuleRouter/types';

export const useStructuredModuleRouting = (
  routingStructure: NavigationRoutingStructure[],
) => {
  return useMemo(() => {
    const validStructure = resolveValidRoutingStructure(routingStructure);
    const navigationPaths = convertToNavigationLevelPathConfig(validStructure);

    return {
      routingStructure: validStructure,
      navigationPaths,
    };
  }, [routingStructure]);
};
